import {
  ACTION_ADD_CUSTOM_FIELDS_FAILURE,
  ACTION_ADD_CUSTOM_FIELDS_REQUEST,
  ACTION_ADD_CUSTOM_FIELDS_SUCCESS,
  ACTION_DELETE_CUSTOM_FIELDS_FAILURE,
  ACTION_DELETE_CUSTOM_FIELDS_REQUEST,
  ACTION_DELETE_CUSTOM_FIELDS_SUCCESS,
  ACTION_GET_CUSTOM_FIELDS_FAILURE,
  ACTION_GET_CUSTOM_FIELDS_REQUEST,
  ACTION_GET_CUSTOM_FIELDS_SUCCESS,
  ACTION_MOD_CUSTOM_FIELDS_FAILURE,
  ACTION_MOD_CUSTOM_FIELDS_REQUEST,
  ACTION_MOD_CUSTOM_FIELDS_SUCCESS,
  ERROR_GET_CUSTOM_FIELDS_SERVER,
} from '@/app/module/custom-fields/definitions'
import request from '@/app/module/request'
import { createAsyncActions, preventParallel } from '@/app/service/util'

const {
  request: getCustomFieldsRequest,
  success: getCustomFieldsSuccess,
  failure: getCustomFieldsFailure,
} = createAsyncActions({
  request: ACTION_GET_CUSTOM_FIELDS_REQUEST,
  success: ACTION_GET_CUSTOM_FIELDS_SUCCESS,
  failure: ACTION_GET_CUSTOM_FIELDS_FAILURE,
})

const {
  request: addCustomFieldsRequest,
  success: addCustomFieldsSuccess,
  failure: addCustomFieldsFailure,
} = createAsyncActions({
  request: ACTION_ADD_CUSTOM_FIELDS_REQUEST,
  success: ACTION_ADD_CUSTOM_FIELDS_SUCCESS,
  failure: ACTION_ADD_CUSTOM_FIELDS_FAILURE,
})

const {
  request: modCustomFieldsRequest,
  success: modCustomFieldsSuccess,
  failure: modCustomFieldsFailure,
} = createAsyncActions({
  request: ACTION_MOD_CUSTOM_FIELDS_REQUEST,
  success: ACTION_MOD_CUSTOM_FIELDS_SUCCESS,
  failure: ACTION_MOD_CUSTOM_FIELDS_FAILURE,
})

const {
  request: deleteCustomFieldsRequest,
  success: deleteCustomFieldsSuccess,
  failure: deleteCustomFieldsFailure,
} = createAsyncActions({
  request: ACTION_DELETE_CUSTOM_FIELDS_REQUEST,
  success: ACTION_DELETE_CUSTOM_FIELDS_SUCCESS,
  failure: ACTION_DELETE_CUSTOM_FIELDS_FAILURE,
})

export {
  addCustomFieldsFailure,
  addCustomFieldsRequest,
  addCustomFieldsSuccess,
  deleteCustomFieldsFailure,
  deleteCustomFieldsRequest,
  deleteCustomFieldsSuccess,
  getCustomFieldsFailure,
  getCustomFieldsRequest,
  getCustomFieldsSuccess,
  modCustomFieldsFailure,
  modCustomFieldsRequest,
  modCustomFieldsSuccess,
}

export const getCustomFields = preventParallel(
  ({ orgId }) => orgId,
  ({ token, orgId }) =>
    (dispatch) => {
      dispatch(getCustomFieldsRequest())

      return request.customFields
        .get({ token, orgId })
        .then(({ allCustomfields = [] } = {}) => {
          dispatch(getCustomFieldsSuccess(allCustomfields))
          return allCustomfields
        })
        .catch((err) => {
          dispatch(
            getCustomFieldsFailure({
              status: err.status,
              message: ERROR_GET_CUSTOM_FIELDS_SERVER,
            }),
          )
          return err
        })
    },
)
